import React from 'react'

import InputMask from 'react-input-mask'

import { IProps, SimpleInput } from '../SimpleInput'

export const MaskInput: React.FC<IProps> = props => {
  return (
    <InputMask {...props} mask={props.mask || ''}>
      <SimpleInput {...props} />
    </InputMask>
  )
}
